/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * Utils for the GizmoKit
 */
export const visibleHeightAtZDepth = (depth, camera) => {
    // vertical fov in radians
    const vFOV = camera.fov * Math.PI / 180;
    // Math.abs to ensure the result is always positive
    return 2 * Math.tan(vFOV / 2) * Math.abs(depth);
};
export const visibleWidthAtZDepth = (depth, camera) => {
    const height = visibleHeightAtZDepth(depth, camera);
    return height * camera.aspect;
};
export const vectorAbs = (v) => {
    v.x = Math.abs(v.x);
    v.y = Math.abs(v.y);
    v.z = Math.abs(v.z);
    return v;
};
// export const toLocalScale
//# sourceMappingURL=GizmoKitUtils.js.map